import React from 'react';

const Aux = (props)  =>  props.children;

export default Aux;


// WEBPACK FOOTER //
// ./src/_components/common/Hoc/index.js